import React, { useState, useEffect, useRef } from "react";
import { Navigate, useNavigate, useLocation } from "react-router-dom";
import { API } from "services";
import { countries } from "utils";
import { Q1P2, Q2P1, Q2P2, Q2P3, Q2P4, QCHECK } from "./texts";
import moment from "moment";
import { enqueueSnackbar, SnackbarProvider } from "notistack";

const isValidUrl = (url) => {
  try {
    new URL(url);
    return true;
  } catch {
    return false;
  }
};

function EditAssessment() {
  const merchantBackground = Q2P1.map((q) => q.text);

  const riskLevel = ["yes", "no", "na"];

  const merchantLocation = Q2P2.map((q) => q.text);

  const merchantProduct = Q2P3.map((q) => q.text);

  const merchantPoint = Q2P4.map((q) => q.text);

  const finalRisk = ["na", "low", "medL", "medH", "high"];

  const recommendation = ["establish", "maintain", "decline", "terminate"];

  const [firstForm, setFirstForm] = useState({
    entity: "",
    country: "",
    clientType: "",
  });

  const [defaultData, setDefaultData] = useState({
    Q1P1a: Array(3).fill(""),
    Q1P1b: Array(2).fill(""),
    Q1P2: Array(Q1P2.length).fill(""),
    Q2P1: Array(merchantBackground.length).fill(""),
    Q2P2: Array(merchantLocation.length).fill(""),
    Q2P3: Array(merchantProduct.length).fill(""),
    Q2P4: Array(merchantPoint.length).fill(""),
    Q3: Array(4).fill(""),
    QCHECK: Array(QCHECK.length).fill(""),
    Doc: Array(QCHECK.length).fill(""),
  });

  const defaultCount = {
    Q2P1: { low: 0, med: 0, high: 0 },
    Q2P2: { low: 0, med: 0, high: 0 },
    Q2P3: { low: 0, med: 0, high: 0 },
    Q2P4: { low: 0, med: 0, high: 0 },
  };

  const [merchants, setMerchants] = useState();
  const [director, setDirector] = useState();
  const [ubo, setUbo] = useState();
  const [merchantToggle, setMerchantToggle] = useState(false);

  const list_merchants = async () => {
    const merchantArr = await API.Operations.Agreement.fetch_all_merchants({
      nolimit: true,
    });
    if (merchantArr) {
      const completedMerchants = merchantArr.filter(
        (item) => item.current_status === "completed",
      );

      setMerchants(completedMerchants);
    }
  };

  const handleChange = (e) => {
    setShowOption(true);
    setFirstForm((prev) => ({
      ...prev,
      [e.target.name]: e.target.value,
    }));
  };

  const firstQuestionChange = (e, merchantToggle) => {
    let arr = [];
    if (merchantToggle) {
      arr = [...defaultData.Q1P1a];
    } else {
      arr = [...defaultData.Q1P1b];
    }
    arr.splice(parseInt(e.target.id), 1, e.target.value);
    setDefaultData((prev) => ({
      ...prev,
      [e.target.name]: arr,
    }));
  };

  const directorChange = (e, directorIndex) => {
    const arr = [...director];
    arr[directorIndex].name = e.target.value;
    setDirector(arr);
  };

  const uboChange = (e, uboIndex) => {
    const arr = [...ubo];
    arr[uboIndex].name = e.target.value;
    setUbo(arr);
  };

  const [showOption, setShowOption] = useState(false);

  const dCountryChange = (e, directorIndex) => {
    const arr = [...director];
    arr[directorIndex].country = e.target.value;
    setDirector(arr);
  };

  const uCountryChange = (e, uboIndex) => {
    const arr = [...ubo];
    arr[uboIndex].country = e.target.value;
    setUbo(arr);
  };

  const emptyAdd = {
    country: "",
    countryType: null,
    name: "",
  };

  const addDirector = () => {
    const arr = [...director];
    const added = arr.concat([emptyAdd]);
    setDirector(added);
  };

  const addUbo = () => {
    const arr = [...ubo];
    const added = arr.concat([emptyAdd]);
    setUbo(added);
  };

  const removeUbo = (uboIndex) => {
    const arr = [...ubo];
    arr.splice(uboIndex, 1);
    setUbo(arr);
  };

  const removeDirector = (directorIndex) => {
    const arr = [...director];
    arr.splice(directorIndex, 1);
    setDirector(arr);
  };

  const merchantClick = (e) => {
    const arr = [...defaultData.Q1P1a];
    arr.splice(0, 1, e.target.value);
    setDefaultData((prev) => ({
      ...prev,
      Q1P1a: arr,
    }));
  };

  const radioClickQ1P2 = (e, index) => {
    const value = e.target.value;

    setDefaultData((prev) => {
      const arr = [...prev.Q1P2];

      // Toggle off if clicking the already selected option
      if (arr[index] === value) {
        arr[index] = "";
      } else {
        arr[index] = value;
      }

      return {
        ...prev,
        Q1P2: arr,
      };
    });
  };

  const radioClickQCHECK = (value, index) => {
    setDefaultData((prev) => {
      const next = [...prev.QCHECK];
      next[index] = value;
      return { ...prev, QCHECK: next };
    });
  };

  const lowChange = (e, questionIndex) => {
    //  console.log(e.target.name);
    const arr = [...defaultData[e.target.name]];
    arr.splice(questionIndex, 1, "l-" + e.target.value.toLowerCase());
    setDefaultData((prev) => ({
      ...prev,
      [e.target.name]: arr,
    }));

    // defaultData[e.target.name][parseInt(questionIndex)]=e.target.value;
  };

  const midChange = (e, questionIndex) => {
    const arr = [...defaultData[e.target.name]];
    arr.splice(questionIndex, 1, "m-" + e.target.value.toLowerCase());
    setDefaultData((prev) => ({
      ...prev,
      [e.target.name]: arr,
    }));

    // defaultData[e.target.name][parseInt(questionIndex)]=e.target.value;
  };

  const highChange = (e, questionIndex) => {
    const arr = [...defaultData[e.target.name]];
    arr.splice(questionIndex, 1, "h-" + e.target.value.toLowerCase());
    setDefaultData((prev) => ({
      ...prev,
      [e.target.name]: arr,
    }));

    // defaultData[e.target.name][parseInt(questionIndex)]=e.target.value;
  };

  const thirdQuestionChange = (e) => {
    const index = Number(e.target.id);
    const value = e.target.value;

    setDefaultData((prev) => {
      const updatedQ3 = [...prev.Q3];
      updatedQ3[index] = value;

      return {
        ...prev,
        Q3: updatedQ3,
      };
    });
  };

  const getRiskLevel = (risk) => {
    let value = "";

    switch (risk) {
      case 0:
        value = "Yes";
        break;

      case 1:
        value = "No";
        break;

      case 2:
        value = "NA";
        break;
    }

    return value;
  };

  const getRiskRating = (results) => {
    let value = "";

    switch (results) {
      case "high":
        value = "High";
        break;

      case "medL":
        value = "Medium Low";
        break;

      case "medH":
        value = "Medium High";
        break;

      case "low":
        value = "Low";
        break;
    }

    return value;
  };

  const getRiskOptions = (optionsIndex) => {
    let value = "";

    switch (optionsIndex) {
      case 0:
        value = "Please Select";
        break;

      case 1:
        value = "Low";
        break;

      case 2:
        value = "Low/Medium";
        break;

      case 3:
        value = "Medium/High";
        break;

      case 4:
        value = "High";
    }

    return value;
  };

  const getRecommendationOptions = (optionsIndex) => {
    let value = "";

    switch (optionsIndex) {
      case 0:
        value = "Establish";
        break;

      case 1:
        value = "Maintain";
        break;

      case 2:
        value = "Decline";
        break;

      case 3:
        value = "Terminate";
    }

    return value;
  };

  const [count, setCount] = useState(defaultCount);
  const [result, setResult] = useState("");

  useEffect(() => {
    calculateRisk();
    initialRadio();
  }, [defaultData]);

  const calculateRisk = () => {
    let newCount = defaultCount;
    for (const question in defaultData) {
      if (!question.match(/Q2/)) continue;
      let low = 0,
        med = 0,
        high = 0;
      for (const item of defaultData[question]) {
        if (item === "l-yes" || item === "l-no") low++;
        if (item === "m-yes" || item === "m-no") med++;
        if (item === "h-yes" || item === "h-no") high++;
      }
      newCount = { ...newCount, [question]: { low, med, high } };
    }

    const sumMed =
      newCount.Q2P1.med +
      newCount.Q2P2.med +
      newCount.Q2P3.med +
      newCount.Q2P4.med;
    const sumHigh =
      newCount.Q2P1.high +
      newCount.Q2P2.high +
      newCount.Q2P3.high +
      newCount.Q2P4.high;

    // According to Risk Scoring Matrix
    let newResult = "";
    if (sumHigh > 0 || sumMed >= 5) newResult = "high";
    else if (sumMed === 4) newResult = "medH";
    else if (sumMed === 3) newResult = "medL";
    else newResult = "low";
    setResult(newResult);
    setCount(newCount);
  };

  //GET RISK FROM DB
  const [riskList, setRiskList] = useState([]);
  const search = useLocation().search;

  const index = () => {
    const arrNumber = new URLSearchParams(search).get("data");
    const newNumber = riskList.length - 1 - arrNumber;

    return newNumber;
  };

  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const id = searchParams.get('id');
  useEffect(() => {
    list_merchants();
    getRisks();
  }, []);

  useEffect(() => {
    setValues(id);
    initialRadio();
  }, [riskList,id]);

  const initialRadio = () => {
    if (
      defaultData.Q1P1a[0].toString() === "0" ||
      defaultData.Q1P1a[0].toString() === "1"
    ) {
      setMerchantToggle(true);
    }
  };

  const getRisks = async () => {
    const result = await API.Compliance.Risk.fetch_all_risk();
    if (result) {
      setRiskList(result);
    }
  };

  const normalizeArray = (value, length, fill = "") => {
    if (Array.isArray(value)) {
      return Array.from({ length }, (_, i) =>
        value[i] !== undefined && value[i] !== null ? value[i] : fill,
      );
    }
    return Array(length).fill(fill);
  };

  const normalizeQCheck = (rawQCheck, length) => {
    return Array.from({ length }, (_, i) => {
      const v = rawQCheck?.[i];

      // Explicit No
      if (v === undefined || v === null || v === "0") {
        return "0";
      }

      // Already correct (multi-link)
      if (Array.isArray(v)) {
        return v;
      }

      // Legacy single link (string)
      if (typeof v === "string") {
        return [v];
      }

      // Safety fallback
      return "0";
    });
  };

  const setValues = (id) => {
    const current = riskList.find(
      (risk) => String(risk.id) === String(id)
    );

    if (!current) return;

    setFirstForm({
      entity: current.entity,
      country: current.country,
      clientType: current.clientType,
    });

    const people = JSON.parse(current.people);
    setDirector(people.director);
    setUbo(people.ubo);

    const fetchedData = JSON.parse(current.answers);
    //console.log(fetchedData)

    setDefaultData({
      Q1P1a: normalizeArray(fetchedData.Q1P1a, 3),
      Q1P1b: normalizeArray(fetchedData.Q1P1b, 2),
      Q1P2: normalizeArray(fetchedData.Q1P2, Q1P2.length),
      Q2P1: normalizeArray(fetchedData.Q2P1, merchantBackground.length),
      Q2P2: normalizeArray(fetchedData.Q2P2, merchantLocation.length),
      Q2P3: normalizeArray(fetchedData.Q2P3, merchantProduct.length),
      Q2P4: normalizeArray(fetchedData.Q2P4, merchantPoint.length),
      Q3: normalizeArray(fetchedData.Q3, 4),

      // 🔥 FIXED
      Doc: normalizeArray(fetchedData.Doc, QCHECK.length),

      QCHECK: normalizeQCheck(fetchedData.QCHECK, QCHECK.length),
    });
  };

  const navigate = useNavigate();
  const submitForm = async () => {
    let countryType = "";

    const fatfList = await API.Compliance.Risk.fetch_country_risk();
    const country_fatf = fatfList[fatfList.length - 1];

    const code = countries.find(
      (item) => item.label === firstForm.country,
    )?.code;
    if (country_fatf.blackList?.includes(code)) countryType = "black";
    else if (country_fatf.grayList?.includes(code)) countryType = "gray";
    else if (country_fatf.othersList?.includes(code)) countryType = "others";

    const categorise = (arr) => {
      return arr.map((item) => {
        const cipher = countries.find(
          (index) => index.label === item.country,
        )?.code;
        let countryType = "";
        if (!item.country) countryType = "test1";
        else if (country_fatf.blackList?.includes(cipher))
          countryType = "black";
        else if (country_fatf.grayList?.includes(cipher)) countryType = "gray";
        else if (country_fatf.othersList?.includes(cipher))
          countryType = "others";
        else countryType = "test2";
        return { ...item, countryType };
      });
    };

    const id = new URLSearchParams(search).get("id");

    const updatedPeople = {
      director: categorise(director),
      ubo: categorise(ubo),
    };

    const body = {
      entity: firstForm.entity,
      answers: JSON.stringify(defaultData),
      count: JSON.stringify(count),
      finalRisk: defaultData.Q3[2] !== "" ? defaultData.Q3[2] : result,
      status: defaultData.Q3[3],
      merchantId: "", //I assume this is supposed to be empty on subsequent entries of the same entity?
      country: firstForm.country,
      clientType: firstForm.clientType,
      countryType,
      people: JSON.stringify(updatedPeople),
    };

    try {
      const result = await API.Compliance.Risk.edit_risk(body,id);
      if (result) {
        
        enqueueSnackbar("Form successfully created!", {
          variant: 'success',
          autoHideDuration: 3000
        })
        navigate(`/compliance/risk-assessment/list`)
      } else {
        enqueueSnackbar("Error creating form", {
          variant: 'error',
          autoHideDuration: 3000
        })
      }
    } catch (err) {
      enqueueSnackbar(err.message, {
        variant: 'error',
        autoHideDuration: 3000
      })
    }
  };
  const saveDraft = async () => {
    let countryType = "";

    try {
      const fatfList = await API.Compliance.Risk.fetch_country_risk();
      const country_fatf = fatfList[fatfList.length - 1];

      const code = countries.find(
        (item) => item.label === firstForm.country,
      )?.code;

      if (country_fatf.blackList?.includes(code)) countryType = "black";
      else if (country_fatf.grayList?.includes(code)) countryType = "gray";
      else if (country_fatf.othersList?.includes(code)) countryType = "others";

      const categorise = (arr) => {
        return (arr || []).map((item) => {
          const cipher = countries.find(
            (index) => index.label === item.country,
          )?.code;
          let countryType = "";

          if (!item.country) countryType = "test1";
          else if (country_fatf.blackList?.includes(cipher))
            countryType = "black";
          else if (country_fatf.grayList?.includes(cipher))
            countryType = "gray";
          else if (country_fatf.othersList?.includes(cipher))
            countryType = "others";
          else countryType = "test2";

          return { ...item, countryType };
        });
      };

      const id = new URLSearchParams(search).get("id");

      const updatedPeople = {
        director: categorise(director),
        ubo: categorise(ubo),
      };

      // 🔥 KEY DIFFERENCE → force DRAFT
      const body = {
        entity: firstForm.entity,
        answers: JSON.stringify(defaultData),
        count: JSON.stringify(count),
        finalRisk: defaultData.Q3?.[2] || result || "",
        status: "DRAFT", // ⭐ important
        merchantId: "",
        country: firstForm.country,
        clientType: firstForm.clientType,
        countryType,
        people: JSON.stringify(updatedPeople),
      };

      const res = await API.Compliance.Risk.save_edit(body, id);

      if (res) {
        enqueueSnackbar("Draft saved!", {
          variant: "success",
          autoHideDuration: 3000,
        });
        navigate(`/compliance/risk-assessment/list`);
      } else {
        enqueueSnackbar("Error saving draft", {
          variant: "error",
          autoHideDuration: 3000,
        });
      }
    } catch (err) {
      enqueueSnackbar(err.message, {
        variant: "error",
        autoHideDuration: 3000,
      });
    }
  };
  
  return (
    <div>
      <p className="text-2xl">Edit Risk Assessment</p>

      <div className="p-2" />

      <div className="p-6 bg-white shadow-md rounded-md flex-col flex md:w-full">
        <p>Date of Assessment: {moment().format("Do MMMM YYYY")}</p>

        <input
          className="border my-2 rounded-md h-[40px] px-2"
          value={firstForm.entity}
          name="entity"
          onChange={handleChange}
        ></input>

        <select
          className="border my-2 rounded-md h-[40px] px-2"
          value={firstForm.country}
          name="country"
          onChange={handleChange}
        >
          <option
            selected
            value
            disabled={showOption}
            className={showOption || firstForm.country ? "hidden" : ""}
          ></option>
          {countries.map((country, countryIndex) => {
            return <option>{countries[countryIndex].label}</option>;
          })}
        </select>

        <select
          className="border my-2 rounded-md h-[40px] px-2"
          value={firstForm.clientType}
          name="clientType"
          onChange={handleChange}
        >
          <option value="m">Merchant</option>
          <option value="p">Partner/Master Merchant</option>
        </select>
      </div>

      <div className="p-2" />

      <div className="p-6 bg-white shadow-md rounded-md flex-col md:flex-row flex md:w-full">
        <div className="flex flex-col md:w-1/2 w-full">
          {director &&
            director.map((directors, directorIndex) => (
              <div className="flex flex-row w-full items-center justify-around py-1">
                <input
                  className="w-1/2 border rounded-md h-[40px] px-2"
                  value={director[directorIndex].name}
                  onChange={(e) => directorChange(e, directorIndex)}
                />

                <div className="p-1" />

                <select
                  className="w-1/2 border rounded-md h-[40px] px-2"
                  value={director[directorIndex].country}
                  onChange={(e) => dCountryChange(e, directorIndex)}
                >
                  <option
                    selected
                    value
                    disabled={director[directorIndex].country}
                    className={director[directorIndex].country ? "hidden" : ""}
                  ></option>

                  {countries.map((country, countryIndex) => (
                    <option key={countryIndex}>
                      {countries[countryIndex].label}
                    </option>
                  ))}
                </select>

                {/* ❌ Remove Director (only show if more than 1) */}
                {director.length > 1 && (
                  <button
                    type="button"
                    onClick={() => removeDirector(directorIndex)}
                    className="ml-2 text-red-600 hover:text-red-800 font-bold"
                  >
                    ✕
                  </button>
                )}
              </div>
            ))}

          <div className="p-2" />

          <button
            className="border h-[35px] rounded-md border-red-800 text-red-800"
            onClick={addDirector}
          >
            ADD DIRECTOR
          </button>
        </div>
        <div className="p-2" />
        <div className="flex flex-col md:w-1/2 w-full">
          {ubo &&
            ubo.map((ubos, uboIndex) => (
              <div className="flex flex-row w-full items-center justify-around py-1">
                <input
                  className="w-1/2 border rounded-md h-[40px] px-2"
                  value={ubo[uboIndex].name}
                  onChange={(e) => uboChange(e, uboIndex)}
                />

                <div className="p-1" />

                <select
                  className="w-1/2 border rounded-md h-[40px] px-2"
                  value={ubo[uboIndex].country}
                  onChange={(e) => uCountryChange(e, uboIndex)}
                >
                  <option
                    selected
                    value
                    disabled={ubo[uboIndex].country}
                    className={ubo[uboIndex].country ? "hidden" : ""}
                  ></option>

                  {countries.map((country, countryIndex) => (
                    <option key={countryIndex}>
                      {countries[countryIndex].label}
                    </option>
                  ))}
                </select>

                {/* ❌ Remove UBO (only show if more than 1) */}
                {ubo.length > 1 && (
                  <button
                    type="button"
                    onClick={() => removeUbo(uboIndex)}
                    className="ml-2 text-red-600 hover:text-red-800 font-bold"
                  >
                    ✕
                  </button>
                )}
              </div>
            ))}

          <div className="p-2" />

          <button
            className="border h-[35px] rounded-md border-red-800 text-red-800"
            onClick={addUbo}
          >
            ADD UBO
          </button>
        </div>
      </div>

      <div className="p-2" />

      <div className="p-6 bg-white shadow-md rounded-md flex-col flex md:w-full ">
        <div className="flex flex-row justify-center">
          <p className="text-2xl font-bold">
            Merchant AML / CFT Risk Assessment - Level 1
          </p>
        </div>
        <div className="p-2" />
        <div className="flex flex-row justify-center">
          <div className="w-[95%] flex flex-row justify-center border-b border-gray-200" />
        </div>
        <div className="p-2" />
        <div className="flex flex-row justify-center text-xl font-semibold">
          <p>1.1 Purpose of Merchant Evaluation</p>
        </div>
        <div className="p-3" />
        {/* where am I storing this */}
        <div className="flex flex-row justify-center">
          <input
            type="radio"
            className="accent-red-800 "
            name="1.1.1"
            checked={merchantToggle}
            onClick={() => setMerchantToggle(true)}
          ></input>
          <div className="p-1" />
          <p>Existing</p>
          <div className="p-2" />
          <input
            type="radio"
            className="accent-red-800"
            name="1.1.1"
            checked={!merchantToggle}
            onClick={() => setMerchantToggle(false)}
          ></input>
          <div className="p-1" />
          <p>New</p>
        </div>
        <div className="p-3" />
        {merchantToggle && (
          <div className="flex flex-row justify-center text-gray-500">
            <p>Routine Review of Existing Merchant</p>
          </div>
        )}
        {merchantToggle && <div className="p-3" />}
        {merchantToggle && (
          <div className="flex flex-row justify-center">
            <input
              type="radio"
              className="accent-red-800"
              name="1.1.2"
              value="1"
              checked={defaultData.Q1P1a[0].toString() === "1"}
              onChange={(e) => merchantClick(e)}
            ></input>
            <div className="p-1" />
            <p>Yes</p>
            <div className="p-2" />
            <input
              type="radio"
              className="accent-red-800"
              name="1.1.2"
              value="0"
              checked={defaultData.Q1P1a[0].toString() === "0"}
              onChange={(e) => merchantClick(e)}
            ></input>
            <div className="p-1" />
            <p>No</p>
          </div>
        )}
        {merchantToggle && <div className="p-3" />}
        <div className="flex flex-row justify-center text-gray-500">
          <p>
            Review as a result of trigger event – Please indicate the trigger
            event:
          </p>
        </div>
        <div className="flex flex-row justify-center">
          <textarea
            className="w-[550px] border rounded-md min-h-[100px] resize-y py-2 px-3 overflow-hidden"
            id={merchantToggle ? "1" : "0"}
            type="text"
            placeholder="Input"
            name={merchantToggle ? "Q1P1a" : "Q1P1b"}
            value={merchantToggle ? defaultData.Q1P1a[1] : defaultData.Q1P1b[0]}
            onChange={(e) => {
              firstQuestionChange(e, merchantToggle);

              e.target.style.height = "auto";
              e.target.style.height = e.target.scrollHeight + "px";
            }}
          ></textarea>
        </div>

        <div className="p-3" />

        <div className="flex flex-row justify-center text-gray-500">
          <p>
            Please provide details regarding the nature of services required by
            client:
          </p>
        </div>

        <div className="flex flex-row justify-center">
          <textarea
            className="w-[550px] border rounded-md min-h-[100px] resize-y p-3 overflow-hidden"
            id={merchantToggle ? "2" : "1"}
            type="text"
            placeholder="Input"
            name={merchantToggle ? "Q1P1a" : "Q1P1b"}
            value={merchantToggle ? defaultData.Q1P1a[2] : defaultData.Q1P1b[1]}
            onChange={(e) => {
              firstQuestionChange(e, merchantToggle);

              e.target.style.height = "auto";
              e.target.style.height = e.target.scrollHeight + "px";
            }}
          ></textarea>
        </div>
        <div className="p-3" />
        <div className="flex flex-row justify-center">
          <p>
            1.2 Establishing or continuing business account with the Merchant is
            NOT allowed if the answer to any of the below questions is "NO"
          </p>
        </div>
        <div className="p-1" />

        {Q1P2.map((question, questionIndex) => {
          const q1Answered = defaultData.Q1P2[0] !== "";
          const q2Answered = defaultData.Q1P2[1] !== "";

          const skipped =
            (questionIndex === 1 && q1Answered && !q2Answered) ||
            (questionIndex === 0 && q2Answered && !q1Answered);

          return (
            <div key={questionIndex} className="py-4">
              <div className="flex items-center justify-center gap-6">
                {/* Question */}
                <p className="w-[45%] text-right text-gray-500">
                  {questionIndex + 1}. {question.text}
                </p>

                {/* Answer / Skip Message */}
                <div className="w-[35%]">
                  {skipped ? (
                    <div className="rounded-md border border-blue-200 bg-blue-50 px-3 py-2 text-sm text-blue-700">
                      {questionIndex === 1
                        ? "Skipped because Question 1 has been answered. Please proceed to Question 3."
                        : "Skipped because Question 2 has been answered. Please proceed to Question 3."}
                    </div>
                  ) : (
                    <div className="flex items-center gap-2">
                      <label className="flex items-center gap-1 cursor-pointer">
                        <input
                          type="radio"
                          name={questionIndex.toString()}
                          className="accent-red-800"
                          value="1"
                          checked={
                            defaultData.Q1P2[questionIndex]?.toString() === "1"
                          }
                          onClick={(e) => radioClickQ1P2(e, questionIndex)}
                        />
                        <span>Yes</span>
                      </label>

                      <label className="flex items-center gap-1 cursor-pointer">
                        <input
                          type="radio"
                          name={questionIndex.toString()}
                          className="accent-red-800"
                          value="0"
                          checked={
                            defaultData.Q1P2[questionIndex]?.toString() === "0"
                          }
                          onClick={(e) => radioClickQ1P2(e, questionIndex)}
                        />
                        <span>No</span>
                      </label>

                      {defaultData.Q1P2[questionIndex] !== "" && (
                        <button
                          type="button"
                          className="ml-3 text-sm text-blue-600 hover:text-blue-800 hover:underline"
                          onClick={() => {
                            const arr = [...defaultData.Q1P2];
                            arr[questionIndex] = "";

                            setDefaultData((prev) => ({
                              ...prev,
                              Q1P2: arr,
                            }));
                          }}
                        >
                          Clear
                        </button>
                      )}
                    </div>
                  )}
                </div>
              </div>
            </div>
          );
        })}

        <div className="p-10" />
        <div className="flex flex-row justify-center">
          <p className="text-2xl font-bold">
            Merchant AML / CFT Risk Assessment Questionnaire and Review – Level
            2
          </p>
        </div>
        <div className="p-2" />
        <div className="flex flex-row justify-center">
          <div className="w-[95%] flex flex-row justify-center border-b border-gray-200" />
        </div>
        <div className="p-2" />
        <div className="flex flex-row justify-center text-xl font-semibold">
          <p>2.1 Merchant / Partner Background</p>
        </div>
        <div className="p-4" />
        <div className="flex flex-row justify-center">
          <p className="break-words text-right w-[40%] ">Risk Level</p>
          <div className="p-2" />
          <div className="flex flex-col justify-center w-[60px] text-green-500">
            <p className="text-center text-green">Low</p>
          </div>
          <div className="p-1" />
          <div className="flex flex-col justify-center w-[60px] text-amber-500">
            <p className="text-center">Medium</p>
          </div>
          <div className="p-1" />
          <div className="flex flex-col justify-center w-[60px] text-red-700">
            <p className="text-center">High</p>
          </div>
        </div>
        {merchantBackground.map((question, questionIndex) => {
          const isRemarks = questionIndex === merchantBackground.length - 1;

          return (
            <div key={questionIndex}>
              <div className="p-4" />

              <div className="flex flex-row justify-center">
                {/* Question text */}
                <p className="break-words text-right w-[40%] text-gray-500">
                  {questionIndex + 1}. {question}
                </p>

                <div className="p-2" />

                {/* 🔴 REMARKS QUESTION */}
                {isRemarks ? (
                  <textarea
                    ref={(element) => {
                      if (element) {
                        element.style.height = "auto";
                        element.style.height = `${element.scrollHeight}px`;
                      }
                    }}
                    className="border border-gray-200 rounded-md p-2 w-[240px] min-h-[80px] resize-y overflow-hidden"
                    value={defaultData.Q2P1[questionIndex] || ""}
                    onChange={(e) => {
                      const newData = [...defaultData.Q2P1];
                      newData[questionIndex] = e.target.value;
                      setDefaultData({
                        ...defaultData,
                        Q2P1: newData,
                      });

                      e.target.style.height = "auto";
                      e.target.style.height = `${e.target.scrollHeight}px`;
                    }}
                    placeholder="Enter remarks"
                  />
                ) : (
                  /* 🟢 RISK QUESTIONS */
                  <>
                    {["l", "m", "h"].map((level) => (
                      <div
                        key={level}
                        className="flex flex-col justify-center mx-1"
                      >
                        <select
                          name="Q2P1"
                          className="border border-gray-200 rounded-md h-[30px] w-[60px]"
                          value={
                            defaultData.Q2P1[questionIndex]?.split("-")[0] ===
                            level
                              ? defaultData.Q2P1[questionIndex].split("-")[1]
                              : ""
                          }
                          onChange={(e) =>
                            level === "l"
                              ? lowChange(e, questionIndex)
                              : level === "m"
                                ? midChange(e, questionIndex)
                                : highChange(e, questionIndex)
                          }
                        >
                          <option value="" hidden />
                          {Object.keys(riskLevel).map((risk) => (
                            <option key={risk} value={riskLevel[risk]}>
                              {getRiskLevel(parseInt(risk))}
                            </option>
                          ))}
                        </select>
                      </div>
                    ))}
                  </>
                )}
              </div>
            </div>
          );
        })}

        <div className="p-4" />
        <div className="flex flex-row justify-center text-xl font-semibold">
          <p>2.2 Merchant / Partner Location</p>
        </div>
        <div className="p-1" />
        <div className="flex flex-row justify-center ">
          <p className="text-center">
            Applicable aspects to assess merchant / partner location: Natural
            owners’ nationality; place of business incorporation; registered
            business address; location of operation.
          </p>
        </div>

        {merchantLocation.map((question, questionIndex) => {
          const isRemarks = questionIndex === merchantLocation.length - 1;

          return (
            <div key={questionIndex}>
              <div className="p-4" />

              <div className="flex flex-row justify-center">
                {/* Question text */}
                <p className="break-words text-right w-[40%] text-gray-500">
                  {questionIndex + 1}. {question}
                </p>

                <div className="p-2" />

                {/* 🔴 REMARKS QUESTION */}
                {isRemarks ? (
                  <textarea
                    ref={(element) => {
                      if (element) {
                        element.style.height = "auto";
                        element.style.height = `${element.scrollHeight}px`;
                      }
                    }}
                    className="border border-gray-200 rounded-md p-2 w-[240px] h-[80px]"
                    value={defaultData.Q2P2[questionIndex] || ""}
                    onChange={(e) => {
                      const newData = [...defaultData.Q2P2];
                      newData[questionIndex] = e.target.value;
                      setDefaultData({
                        ...defaultData,
                        Q2P2: newData,
                      });
                      e.target.style.height = "auto";
                      e.target.style.height = e.target.scrollHeight + "px";
                    }}
                    placeholder="Enter remarks"
                  />
                ) : (
                  /* 🟢 RISK QUESTIONS */
                  <>
                    {["l", "m", "h"].map((level) => (
                      <div
                        key={level}
                        className="flex flex-col justify-center mx-1"
                      >
                        <select
                          name="Q2P2"
                          className="border border-gray-200 rounded-md h-[30px] w-[60px]"
                          value={
                            defaultData.Q2P2[questionIndex]?.split("-")[0] ===
                            level
                              ? defaultData.Q2P2[questionIndex].split("-")[1]
                              : ""
                          }
                          onChange={(e) =>
                            level === "l"
                              ? lowChange(e, questionIndex)
                              : level === "m"
                                ? midChange(e, questionIndex)
                                : highChange(e, questionIndex)
                          }
                        >
                          <option value="" hidden />
                          {Object.keys(riskLevel).map((risk) => (
                            <option key={risk} value={riskLevel[risk]}>
                              {getRiskLevel(parseInt(risk))}
                            </option>
                          ))}
                        </select>
                      </div>
                    ))}
                  </>
                )}
              </div>
            </div>
          );
        })}
        <div className="p-4" />
        <div className="flex flex-row justify-center text-xl font-semibold">
          <p>2.3 Merchant Product and Transaction History</p>
        </div>
        {merchantProduct.map((question, questionIndex) => {
          const isRemarks = questionIndex === merchantProduct.length - 1;

          return (
            <div key={questionIndex}>
              <div className="p-4" />

              <div className="flex flex-row justify-center">
                {/* Question text */}
                <p className="break-words text-right w-[40%] text-gray-500">
                  {questionIndex + 1}. {question}
                </p>

                <div className="p-2" />

                {/* 🔴 REMARKS QUESTION */}
                {isRemarks ? (
                  <textarea
                    ref={(element) => {
                      if (element) {
                        element.style.height = "auto";
                        element.style.height = `${element.scrollHeight}px`;
                      }
                    }}
                    className="border border-gray-200 rounded-md p-2 w-[240px] h-[80px]"
                    value={defaultData.Q2P3[questionIndex] || ""}
                    onChange={(e) => {
                      const newData = [...defaultData.Q2P3];
                      newData[questionIndex] = e.target.value;
                      setDefaultData({
                        ...defaultData,
                        Q2P3: newData,
                      });
                      e.target.style.height = "auto";
                      e.target.style.height = e.target.scrollHeight + "px";
                    }}
                    placeholder="Enter remarks"
                  />
                ) : (
                  /* 🟢 RISK QUESTIONS */
                  <>
                    {["l", "m", "h"].map((level) => (
                      <div
                        key={level}
                        className="flex flex-col justify-center mx-1"
                      >
                        <select
                          name="Q2P3"
                          className="border border-gray-200 rounded-md h-[30px] w-[60px]"
                          value={
                            defaultData.Q2P3[questionIndex]?.split("-")[0] ===
                            level
                              ? defaultData.Q2P3[questionIndex].split("-")[1]
                              : ""
                          }
                          onChange={(e) =>
                            level === "l"
                              ? lowChange(e, questionIndex)
                              : level === "m"
                                ? midChange(e, questionIndex)
                                : highChange(e, questionIndex)
                          }
                        >
                          <option value="" hidden />
                          {Object.keys(riskLevel).map((risk) => (
                            <option key={risk} value={riskLevel[risk]}>
                              {getRiskLevel(parseInt(risk))}
                            </option>
                          ))}
                        </select>
                      </div>
                    ))}
                  </>
                )}
              </div>
            </div>
          );
        })}
        <div className="mt-6">
          <div className="flex flex-row justify-center text-xl font-semibold">
            <p>2.4 Merchant / Partner Contact Point and Relationship</p>
          </div>
          {merchantPoint.map((question, questionIndex) => {
            const isRemarks = questionIndex === merchantPoint.length - 1;

            return (
              <div key={questionIndex}>
                <div className="p-4" />

                <div className="flex flex-row justify-center">
                  {/* Question text */}
                  <p className="break-words text-right w-[40%] text-gray-500">
                    {questionIndex + 1}. {question}
                  </p>

                  <div className="p-2" />

                  {/* 🔴 REMARKS QUESTION */}
                  {isRemarks ? (
                    <textarea
                    ref={(element) => {
                      if (element) {
                        element.style.height = "auto";
                        element.style.height = `${element.scrollHeight}px`;
                      }
                    }}
                      className="border border-gray-200 rounded-md p-2 w-[240px] h-[80px]"
                      value={defaultData.Q2P4[questionIndex] || ""}
                      onChange={(e) => {
                        const newData = [...defaultData.Q2P4];
                        newData[questionIndex] = e.target.value;
                        setDefaultData({
                          ...defaultData,
                          Q2P4: newData,
                        });
                        e.target.style.height = "auto";
                        e.target.style.height = e.target.scrollHeight + "px";
                      }}
                      placeholder="Enter remarks"
                    />
                  ) : (
                    /* 🟢 RISK QUESTIONS */
                    <>
                      {["l", "m", "h"].map((level) => (
                        <div
                          key={level}
                          className="flex flex-col justify-center mx-1"
                        >
                          <select
                            name="Q2P4"
                            className="border border-gray-200 rounded-md h-[30px] w-[60px]"
                            value={
                              defaultData.Q2P4[questionIndex]?.split("-")[0] ===
                              level
                                ? defaultData.Q2P4[questionIndex].split("-")[1]
                                : ""
                            }
                            onChange={(e) =>
                              level === "l"
                                ? lowChange(e, questionIndex)
                                : level === "m"
                                  ? midChange(e, questionIndex)
                                  : highChange(e, questionIndex)
                            }
                          >
                            <option value="" hidden />
                            {Object.keys(riskLevel).map((risk) => (
                              <option key={risk} value={riskLevel[risk]}>
                                {getRiskLevel(parseInt(risk))}
                              </option>
                            ))}
                          </select>
                        </div>
                      ))}
                    </>
                  )}
                </div>
              </div>
            );
          })}
          <div className="p-4" />
          <div className="flex flex-row justify-center text-xl font-semibold">
            <p>2.5 Overall Merchant Risk Assessment Rating</p>
          </div>
          <div className="p-4" />
          <div className="flex flex-row justify-center">
            <div className="flex flex-col justify-center">
              <p className="break-words text-right  ">Risk</p>
              <p className="break-words text-right  ">2.1</p>
              <p className="break-words text-right  ">2.2</p>
              <p className="break-words text-right  ">2.3</p>
              <p className="break-words text-right  ">2.4</p>
              <p className="break-words text-right  ">Total</p>
            </div>
            <div className="p-2" />
            <div className="flex flex-col justify-center  ">
              <p className="text-center text-green-500 w-[60px]">Low</p>
              {Object.keys(count).map((counts, countIndex) => (
                <div key={countIndex}>
                  <p className="text-center">{count[counts].low}</p>
                </div>
              ))}
              <p className="text-center">
                {count.Q2P1.low +
                  count.Q2P2.low +
                  count.Q2P3.low +
                  count.Q2P4.low}
              </p>
            </div>
            <div className="p-1" />
            <div className="flex flex-col justify-center  ">
              <p className="text-center text-amber-500 w-[60px]">Medium</p>
              {Object.keys(count).map((counts, countIndex) => (
                <div key={countIndex}>
                  <p className="text-center">{count[counts].med}</p>
                </div>
              ))}
              <p className="text-center">
                {count.Q2P1.med +
                  count.Q2P2.med +
                  count.Q2P3.med +
                  count.Q2P4.med}
              </p>
            </div>
            <div className="p-1" />
            <div className="flex flex-col justify-center ">
              <p className="text-center text-red-700 w-[60px]">High</p>
              {Object.keys(count).map((counts, countIndex) => (
                <div key={countIndex}>
                  <p className="text-center">{count[counts].high}</p>
                </div>
              ))}
              <p className="text-center">
                {count.Q2P1.high +
                  count.Q2P2.high +
                  count.Q2P3.high +
                  count.Q2P4.high}
              </p>
            </div>
          </div>

          <div className="p-10" />
          <div className="flex flex-row justify-center">
            <p className="text-2xl font-bold">
              Risk Evaluation and CDD Measures Application
            </p>
          </div>
          <div className="p-2" />
          <div className="flex flex-row justify-center">
            <div className="w-[95%] flex flex-row justify-center border-b border-gray-200" />
          </div>

          <div className="p-4" />
          <div className="flex-row flex justify-center ">
            <p className="w-[20%] text-right mx-2">
              <span className="font-semibold ">Section 1: </span>&nbsp;Overall
              Risk Rating of Client
            </p>
            <p className="w-[30%] mx-2">{getRiskRating(result)}</p>
          </div>
          <div className="p-4" />
          <div className="flex-row flex justify-center ">
            <p className="w-[20%] text-right mx-2 flex flex-col justify-center">
              <div className="">
                <span className="font-semibold ">Section 2: </span>
                &nbsp;Justifications
              </div>
            </p>
            <textarea
              id="1"
              ref={(element) => {
                if (element) {
                  element.style.height = "auto";
                  element.style.height = `${element.scrollHeight}px`;
                }
              }}
              className="border rounded-md min-h-[50px] w-[30%] mx-2 px-2 py-2 resize-y"
              type="text"
              value={defaultData.Q3[1]}
              onChange={(e) => thirdQuestionChange(e)}
            ></textarea>
          </div>
          <div className="p-4" />
          <div className="flex-row flex w-full justify-center ">
            <p className="w-[20%] text-right mx-2 flex flex-col justify-center">
              <div className="">
                <span className="font-semibold ">Section 3: </span>&nbsp;Final
                Risk Rating – Adjusted
              </div>
            </p>
            <select
              id="2"
              className="border rounded-md h-[50px] w-[30%] mx-2 px-2"
              value={defaultData.Q3[2]}
              onChange={(e) => thirdQuestionChange(e)}
            >
              {finalRisk.map((options, optionsIndex) => (
                <option key={optionsIndex} value={finalRisk[optionsIndex]}>
                  {getRiskOptions(optionsIndex)}
                </option>
              ))}
            </select>
              <button
                type="button"
                className="h-[50px] px-4 mx-2 border border-gray-400 rounded-md hover:bg-gray-100"
                onClick={() => {
                  setDefaultData((prev) => {
                    const updatedQ3 = [...prev.Q3];
                    updatedQ3[2] = '';

                    return {
                      ...prev,
                      Q3: updatedQ3,
                    };
                  });
                }}
              >
                Clear
              </button>
          </div>
          <div className="p-4" />
          <div className="flex flex-row w-full justify-center items-center">
            <div className="w-[20%] text-right mx-2 flex flex-col justify-center">
              <div>
                <span className="font-semibold">Section 4: </span>
                Recommendation – Business Relationship with Merchant / Partner
              </div>
            </div>

            <select
              id="3"
              className="border rounded-md h-[50px] w-[30%] mx-2 px-2"
              value={defaultData.Q3[3] || ''}
              onChange={thirdQuestionChange}
            >
              <option value="">Select Recommendation</option>

              {recommendation.map((option, optionsIndex) => (
                <option key={optionsIndex} value={option}>
                  {getRecommendationOptions(optionsIndex)}
                </option>
              ))}
            </select>

            <button
              type="button"
              className="h-[50px] px-4 mx-2 border border-gray-400 rounded-md hover:bg-gray-100"
              onClick={() => {
                setDefaultData((previousData) => {
                  const updatedQ3 = [...previousData.Q3];
                  updatedQ3[3] = '';

                  return {
                    ...previousData,
                    Q3: updatedQ3,
                  };
                });
              }}
            >
              Clear
            </button>
          </div>

          {/* Header */}
          <div className="grid grid-cols-[50px_1fr_80px_80px] gap-4 px-4 py-2 text-sm font-semibold text-gray-500 border-b">
            <div>No.</div>
            <div>Requirement</div>
            <div className="text-center">Yes</div>
            <div className="text-center">No</div>
          </div>

          {/* Rows */}
          {QCHECK.map((question, index) => {
            const stored = defaultData.QCHECK?.[index];
            const isYes = Array.isArray(stored);

            return (
              <div
                key={index}
                className="grid grid-cols-[50px_1fr_80px_80px] gap-4 px-4 py-3 items-start border-b hover:bg-gray-50"
              >
                {/* Number */}
                <div className="text-gray-500 font-medium">{index + 1}.</div>

                {/* Question text */}
                <div className="text-gray-600 space-y-2">
                  {question.title && (
                    <p className="font-medium">{question.title}</p>
                  )}

                  {question.subtitle && (
                    <p className="font-medium">{question.subtitle}</p>
                  )}

                  {question.text && (
                    <p>{question.text}</p>
                  )}

                  <div className="mt-2">
                    <label className="block text-sm italic text-gray-500 mb-1">
                      Remarks
                    </label>
                    <textarea
                      ref={(element) => {
                        if (element) {
                          element.style.height = "auto";
                          element.style.height = `${element.scrollHeight}px`;
                        }
                      }}
                      className="w-full min-h-9 rounded-md border border-gray-300 px-3 py-2 resize-y overflow-hidden focus:outline-none focus:ring-2 focus:ring-blue-500"
                      placeholder="Enter remarks..."
                      value={defaultData.Doc?.[index] ?? ""}
                      onChange={(e) => {
                        const arr = [...(defaultData.Doc ?? [])];
                        arr[index] = e.target.value;
                        setDefaultData((prev) => ({
                          ...prev,
                          Doc: arr,
                        }));

                        e.target.style.height = "auto";
                        e.target.style.height = `${e.target.scrollHeight}px`;
                      }}
                    />
                  </div>
                </div>

                {/* YES */}
                <div className="flex justify-center">
                  <input
                    type="radio"
                    name={`qcheck-${index}`}
                    className="accent-red-800"
                    checked={isYes}
                    onChange={() =>
                      radioClickQCHECK(
                        Array.isArray(stored) ? stored : [],
                        index,
                      )
                    }
                  />
                </div>

                {/* NO */}
                <div className="flex justify-center">
                  <input
                    type="radio"
                    name={`qcheck-${index}`}
                    className="accent-red-800"
                    checked={!isYes}
                    onChange={() => radioClickQCHECK("0", index)}
                  />
                </div>

                {/* LINK INPUT (ONLY WHEN YES) */}
                {isYes && (
                  <div className="col-span-full pl-[50px] pr-[80px] mt-2 space-y-2">
                    {(Array.isArray(stored) ? stored : []).map((link, i) => (
                      <div key={i} className="flex gap-2">
                        <input
                          type="text"
                          className="border rounded-md h-[36px] w-full px-2"
                          placeholder="https://example.com"
                          value={link}
                          onChange={(e) => {
                            const next = [...stored];
                            next[i] = e.target.value;
                            radioClickQCHECK(next, index);
                          }}
                        />

                        <button
                          type="button"
                          className="text-red-600 font-bold"
                          onClick={() => {
                            const next = stored.filter((_, idx) => idx !== i);
                            radioClickQCHECK(next, index);
                          }}
                        >
                          ✕
                        </button>
                      </div>
                    ))}

                    <button
                      type="button"
                      className="text-sm text-blue-600 underline"
                      onClick={() =>
                        radioClickQCHECK(
                          Array.isArray(stored) ? [...stored, ""] : [""],
                          index,
                        )
                      }
                    >
                      + Add another link
                    </button>
                  </div>
                )}
              </div>
            );
          })}
        </div>

        <div className="p-4" />
        <div className="w-full flex flex-row justify-center gap-4">
          <button
            className="border h-[35px] rounded-md border-red-800 text-red-800 w-[175px] hover:bg-[#f8f5f5] transition-all duration-500 delay-75"
            onClick={submitForm}
          >
            SUBMIT
          </button>

          <button
            className="border h-[35px] rounded-md border-red-800 text-red-800 w-[175px] hover:bg-[#f8f5f5] transition-all duration-500 delay-75"
            onClick={saveDraft}
          >
            SAVE DRAFT
          </button>
        </div>
        <div className="p-4" />
      </div>
    </div>
  );
}

export default EditAssessment;
